import { useFormContext } from "src/lib/templates";
import { LoginInitialValue } from "../initialValues";

export const useLoginFormContext = () => useFormContext<LoginInitialValue>();
